import React from "react";
import Loader from "../Loader";
import { Button } from "@mui/material";
import { Link, useNavigate, NavLink } from "react-router-dom";
import "./Error.scss";

const Error = () => {
  const navigate = useNavigate();
  return (
    <>
      {/* <AuthHeader /> */}
      <Loader />
      <div className="pagenotfound-page display-2 text-center">
        <div className="contain-width">
          <div className="pagenotfound-img">
            <svg
              width="607"
              height="226"
              viewBox="0 0 607 226"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M437 177.716V146.288L529.578 0.0170898H555.786V44.7614H539.805L477.483 143.519V145.223H606.709V177.716H437ZM541.084 218.199V168.128L541.51 154.065V0.0170898H578.797V218.199H541.084Z"
                fill="#566FFF"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M303.5 0.0170898C241.368 0.0170898 191 50.3851 191 112.517C191 174.649 241.368 225.017 303.5 225.017C365.632 225.017 416 174.649 416 112.517C416 50.3851 365.632 0.0170898 303.5 0.0170898ZM358.195 177.763C359.255 177.845 360.987 177.98 363.718 178.307C363.733 178.307 363.748 178.337 363.688 178.337C361.179 179.809 302.139 194.186 263.064 171.516C257.67 168.392 244.315 160.429 236.037 144.956C231.626 136.721 230.582 129.753 230.131 126.742C230.122 126.677 230.112 126.614 230.103 126.552C228.135 113.617 231.275 102.29 242.632 94.2527C243.699 93.5016 244.375 91.3833 244.3 89.9561C243.819 80.8972 244.345 71.9585 246.643 63.155C252.022 42.5884 266.879 32.1173 288.017 34.521C295.348 35.3473 302.739 35.4524 310.086 34.7764C316.14 34.2205 322.495 35.0919 328.489 36.3839C334.318 37.6458 338.645 41.657 341.529 46.7948C339.374 47.3013 337.217 47.7605 335.068 48.2178C329.951 49.307 324.883 50.3857 320.016 52.0679C315.133 53.7505 310.341 56.5148 306.345 59.8048C301.102 64.1164 301.072 69.4196 305.969 74.242C310 78.217 314.528 81.694 319.036 85.1556C319.418 85.4488 319.8 85.7419 320.181 86.0351C330.652 94.0875 339.306 103.627 345.105 115.555C345.781 116.953 346.381 118.38 346.922 119.822L347.839 122.271C334.994 124.344 306.33 112.446 283.51 95.4696C285.869 101.419 289.339 105.67 293.11 109.606C304.557 121.565 318.994 128.746 334.138 134.695C335.673 135.294 337.215 135.88 338.758 136.466C342.71 137.969 346.672 139.475 350.573 141.215C334.228 142.792 318.559 140.118 303.355 134.184C288.122 128.25 274.736 119.401 262.147 108.54C262.346 109.144 262.531 109.755 262.717 110.368C263.137 111.75 263.558 113.137 264.13 114.459C269.163 126.042 278.237 133.959 288.573 140.524C303.656 150.109 320.467 154.751 337.999 157.079C341.717 157.576 345.439 158.034 349.161 158.492C351.967 158.837 354.772 159.181 357.574 159.543C322.735 165.627 289.609 162.608 259.593 142.206C263.274 147.84 268.081 152.482 273.475 156.448C290.225 168.752 308.028 172.012 317.207 173.304C329.541 175.047 345.585 176.729 353.833 177.36C354.764 177.435 356.267 177.571 357.183 177.676C357.416 177.703 357.745 177.728 358.195 177.763ZM284.667 50.4004C284.667 49.3788 283.029 48.5676 281.016 48.5676C279.003 48.5676 277.365 49.3788 277.365 50.4004C277.365 51.422 279.003 52.2332 281.016 52.2332C283.029 52.2332 284.667 51.4069 284.667 50.4004Z"
                fill="#566FFF"
              />
              <path
                d="M0 177.699V146.271L92.5781 0H118.786V44.7443H102.805L40.483 143.501V145.206H169.709V177.699H0ZM104.084 218.182V168.111L104.51 154.048V0H141.797V218.182H104.084Z"
                fill="#566FFF"
              />
            </svg>
          </div>
          <div className="pagenotfound-content">
            <h1>
              Page <span>has</span> not found!
            </h1>
            <p>
              Sorry we can't seem to find the page you're looking for. It might
              be an old link or may be it moved
            </p>
            <div className="common-btn mt-10">
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={() => {
                  navigate("/");
                }}
              >
                Back to Home
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error;
